import getChangedItems from '../get-changed-items';

const getChanges = ({ optionalChildren, displayOptions }) => {
  const changedChildren = getChangedItems(optionalChildren);
  const changedDisplayOptions = getChangedItems(displayOptions);

  return [changedChildren, changedDisplayOptions];
};

export default getChanges;
